import { getFullUrl } from 'hubspot-url-utils';
const SubDomainOverrideKey = 'EmbeddedAcademy:subDomainOverride';
const override = sessionStorage.getItem(SubDomainOverrideKey);
const subDomain = override !== null && override !== void 0 ? override : 'app';
export const EmbeddedUIBaseURL = `${getFullUrl(subDomain)}/embedded-academy-ui`;